import { messageStoreErrors } from '@ringcentral-integration/commons/modules/MessageStore';

export default {
  [messageStoreErrors.deleteFailed]:
    'Cannot delete the voicemail due to internal server error.',
} as const;
